import React from 'react'
import PropTypes from 'prop-types'


const MessagesListItem = ({ showMessageDetails, message}) => {
  return(
    <div 
      onClick={()=> showMessageDetails(message)} 
      className={`row message-list__item ${message.read ? 'message-list__item--read' : ''}`}>
      <div className="col-12 col-lg">
        {message.title}
      </div>
    </div>
  )
}

MessagesListItem.propTypes = {
  message: PropTypes.object,
  showMessageDetails: PropTypes.func
}

export default MessagesListItem
